// extracted by mini-css-extract-plugin
export default {"blogPage":"blog_blogPage__UR9kS","link":"blog_link__+O1Wc","webisteLink":"blog_webisteLink__-PGWw"};